const SCHEME_PATTERN = /^[a-z][a-z\d+.-]*:/i;
const DOMAIN_PATTERN =
  /^(?:[a-z\d](?:[a-z\d-]*[a-z\d])?\.)+[a-z]{2,}(?::\d+)?(?:[/?#].*)?$/i;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


export class BookLinkValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'BookLinkValidationError';
  }
}

export const normalizeBookLink = (rawHref) => {
  let href = String(rawHref || '').trim();
  if (!href) {
    throw new BookLinkValidationError('Saisissez une adresse de lien.');
  }

  if (href.startsWith('#')) {
    if (href.length === 1) {
      throw new BookLinkValidationError('Saisissez une ancre complète.');
    }
    return { href, target: null, rel: null };
  }

  if (href.startsWith('/') && !href.startsWith('//')) {
    return { href, target: null, rel: null };
  }

  if (/^mailto:/i.test(href)) {
    const email = href.slice('mailto:'.length).split('?')[0];
    if (!EMAIL_PATTERN.test(email)) {
      throw new BookLinkValidationError(
        'L’adresse e-mail du lien est invalide.'
      );
    }
    return { href, target: null, rel: null };
  }

  if (!SCHEME_PATTERN.test(href) && DOMAIN_PATTERN.test(href)) {
    href = `https://${href}`;
  }

  let parsed;
  try {
    parsed = new URL(href);
  } catch {
    throw new BookLinkValidationError('L’adresse du lien est invalide.');
  }
  if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname) {
    throw new BookLinkValidationError('Ce type de lien n’est pas autorisé.');
  }

  return {
    href,
    target: '_blank',
    rel: 'noopener noreferrer',
  };
};

